import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { useTranslator } from '@picsart/rc/services/localization';
import useStyles from './styles';
import type { SettingsLink } from './types';

interface SettingsLinkButtonProps {
  link: SettingsLink;
  onClick: (url: string) => void;
}

const SettingsLinkButton = ({ link, onClick }: SettingsLinkButtonProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <InlineButton
      className={classes.actionButton}
      dataTestId={`genai-settings-link-${link.label}`}
      size="large"
      startIcon={link.icon}
      alignment="start"
      isFullWidth
      isWithoutBorder
      onClick={() => onClick(link.url)}
    >
      {translate(link.label)}
    </InlineButton>
  );
};

export default SettingsLinkButton;
